<script setup>

    import { computed } from 'vue'
    import { util } from '@/Helpers'
    import moment from 'moment'
    import { storeToRefs } from 'pinia'
    import LiveInScheduleViewBlock from '@/Components/Caregiver/LiveInScheduleViewBlock.vue'
    import { useCaregiverSingleStore } from '@/Stores'

    const caregiverSingleStore = useCaregiverSingleStore()
    const { userFocusedOn } = storeToRefs(caregiverSingleStore)

    const props = defineProps({
        schedule_start_date: {
            type: String,
            required: true
        },
        block: {
            type: Object,
            required: true
        },
        displayMode: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'search', 'search_verbose'].includes(value)
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    })

    const isCurrentOrFutureWeek = computed(() => {
        const lastSunday = moment(util.date.lastSunday(), util.date.date_format)
        const startDate = moment(props.schedule_start_date, util.date.date_format)

        return startDate.isSameOrAfter(lastSunday);
    })

</script>

<template>
    <li
        class="relative flex group justify-center ml-05 mr-5"
        :class="[
            `col-start-${util.date.dateDiff(schedule_start_date, block.start_date) + 1}`,
            {
                'z-40': userFocusedOn == 'live-in' && props.displayMode === 'default',
                'z-10': userFocusedOn == 'live-out' && props.displayMode === 'default',
                'z-90': userFocusedOn == null && props.displayMode === 'default',
                'z-10': props.displayMode === 'search',
                'z-40': userFocusedOn == 'live-in' && props.displayMode === 'search_verbose',
                'z-10': (userFocusedOn == 'live-out' || userFocusedOn == 'client_shift') && props.displayMode === 'search_verbose',
                'z-20': userFocusedOn == null && props.displayMode === 'search_verbose',
            }
        ]"
        :style="`grid-row: ${util.schedule.startWithTz(block.start_time)} / span ${util.schedule.span(block.duration)}`"
    >
        <LiveInScheduleViewBlock
            :isCurrentOrFutureWeek="isCurrentOrFutureWeek"
            :block="block"
            :size="util.schedule.sizeOf(block)"
            :showLabel="showLabel"
            :class="[
                'group absolute flex inset-0.5 flex-col overflow-y-auto text-xs whitespace-nowrap cursor-default border-dashed border-opacity-10 text-lifeworx-purple-600  border-lifeworx-purple-600',
                {
                    'rounded-t-lg': block.continues,
                    'rounded-b-lg': block.continuation,
                    'rounded-lg': !block.continues && !block.continuation,
                    'p-0.5 border-2': ['3xs', '2xs', 'xs'].includes(util.schedule.sizeOf(block)),
                    'p-1 border-2': ['sm', 'md', 'lg', 'xl', '2xl'].includes(util.schedule.sizeOf(block)),
                    // 'backdrop-blur-sm bg-opacity-20': block.id && block.overlaps,
                    'backdrop-opacity-75 backdrop-blur-sm bg-opacity-10 bg-lifeworx-purple-600 text-opacity-50': props.displayMode === 'search',
                    'backdrop-opacity-75 backdrop-blur-sm bg-opacity-20 bg-lifeworx-purple-600 text-opacity-50': userFocusedOn !== 'live-in' && (props.displayMode === 'default' || props.displayMode === 'search_verbose'),
                    'backdrop-opacity-75 backdrop-blur-sm bg-opacity-70 bg-lifeworx-purple-150 text-opacity-100 border-opacity-50': userFocusedOn == 'live-in' && (props.displayMode === 'default' || props.displayMode === 'search_verbose'),
                }
            ]"
        />
    </li>
</template>
